import React from 'react'

const Call = () => {
  return (
    <div>Call</div>
  )
}

export default Call